import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Paper } from "@mui/material";

const columns = [
  { field: "name", headerName: "Name", flex: 1 },
  { field: "email", headerName: "Corporate Email", flex: 1 },
];

export default function AbsentEmployeesTable({ employees }) {


  const rows = employees?.map((emp, index) => ({
    id: index + 1,
    name: `${emp.details?.First_Name || ""} ${emp.details?.Last_Name || ""}`,
    email: emp.details?.Corporate_Email_ID || "N/A",
  })) || [];

  return (
    <Box p={0}>
      <Typography variant="h5" gutterBottom>
        Absent Employees [  {employees.length} ]
      </Typography>
      <Paper elevation={3} sx={{ padding: 0 }}>
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            sx={{
              fontSize: "14px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "rgb(100, 95, 95)",
                color: "white",
              },
              "& .MuiDataGrid-cell": { textAlign: "center" },
            }}
          />
        </div>
      </Paper>
    </Box>
  );
}
